import React from "react";
import Link from "next/link";

import Image from "@/components/shared/Image";
import { sobre, socialMediasPetAnjo } from "./mock";
import { Descriptors, Keyword } from "@/utils/constants";

import styles from "./styles.module.scss";

export type ItemFooter = {
  title: string;
  url: string;
  newTab?: boolean;
};

const Footer = () => {
  const renderLinks = (items: ItemFooter[], title?: string) => {
    return (
      <>
        {title ? <h2 className="subtitle-sm">{title}</h2> : null}
        <ul className={styles.footer_link_list}>
          {items.map((item: ItemFooter, index: number) => (
            <li key={`${item.url}-${index}`}>
              <Link
                href={item.url}
                title={item.title}
                target={item.newTab ? "_blank" : "_self"}
                rel="noreferrer"
                className="body-text-sm"
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </>
    );
  };

  return (
    <div className={styles.footer}>
      <div className={styles.footer_wrapper} data-testid="footer">
        <div className={styles.container}>
          <div className={styles.footer_grid_layout}>
            <div className={styles.footer_logo}>
              <Link href="/">
                <Image
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/pet-anjo-logo-white.svg"
                  alt="Logo Pet Anjo"
                  height={86}
                  width={285}
                  loading="lazy"
                />
              </Link>
            </div>
            <div className={styles.footer_column}>
              {renderLinks(sobre, Keyword.LEARN_MORE)}
            </div>
            <div className={styles.footer_column}>
              <div>
                <h2 className="subtitle-sm">{Descriptors.FALE_CONOSCO}</h2>
              </div>
              <p className="body-text-sm">
                Nos envie um e-mail através <br />
                do link{" "}
                <Link
                  href="https://atendimentopetanjo.zendesk.com/hc/pt-br/requests/new"
                  target="_blank"
                >
                  Fale Conosco
                </Link>
              </p>
              <ul className={styles.footer_list}>
                {socialMediasPetAnjo.map((media, index) => (
                  <li key={index}>
                    <Link href={media.link} target="_blank">
                      <Image
                        className={styles.media_icon}
                        src={media.icon}
                        alt={`Rede Social ${media.name}`}
                        width={24}
                        height={24}
                        loading="lazy"
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <p className={styles.footer_infos}>
            <span>Pet Anjo Franqueadora LTDA - CNPJ: 45.585.966/0001-76</span>
            <span>
              Rua Professora Helena Moura Lacerda, 140 - Andar 1, sala 2 - Vila
              Hamburguesa - São Paulo - SP - 05319-015
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
